// import React from 'react';
// import {Form, Row, Col} from 'react-bootstrap';

// const HorizontalFieldsRow = ({
//     fields, // array các object { label, name, value, onChange, isInvalid, error, placeholder, type }
//     colPerField // số lượng Col, ví dụ 6 nếu 2 field, 4 nếu 3 field, hoặc tự động chia
// }) => {
//     const colSize = colPerField || 12 / fields.length;

//     return (
//         <Form.Group as={Row} className="mb-3">
//             {fields.map((f, idx) => {
//                 if (!f || !f.label) {
//                     return <Col sm={colSize} key={`empty-${idx}`} />;
//                 }
                
//                 return (
//                     <Col sm={colSize} key={f.name}>
//                         <Form.Group
//                             as={Row}
//                             className="mb-3 align-items-center"
//                         >
//                             <Form.Label className="col-sm-3 col-form-label">
//                                 {f.label}
//                             </Form.Label>
//                             <Col sm="9">
//                                 <Form.Control
//                                     placeholder={f.placeholder || f.label}
//                                     type={f.type || 'text'}
//                                     name={f.name}
//                                     value={f.value}
//                                     onChange={f.onChange}
//                                     isInvalid={!!f.isInvalid}
//                                 />
//                                 <Form.Control.Feedback type="invalid">
//                                     {f.error}
//                                 </Form.Control.Feedback>
//                             </Col>
//                         </Form.Group>
//                     </Col>
//                 );
//             })}
//         </Form.Group>
//     );
// };

// export default HorizontalFieldsRow;

import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const HorizontalFieldsRow = ({
  fields,           // array of objects: { label, name, component?, value, onChange, isInvalid, error, placeholder, type }
  colPerField,      // optional override for each column width
}) => {
  const colSize = colPerField || 12 / fields.length;

  return (
    <Form.Group as={Row} className="mb-3">
      {fields.map((f, idx) => {
        // allow empty columns
        if (!f || (!f.label && !f.component)) {
          return <Col sm={colSize} key={`empty-${idx}`} />;
        }

        return (
          <Col sm={colSize} key={f.name || idx}>
            <Form.Group as={Row} className="mb-3">
              {f.label && (
                <Form.Label className="col-sm-3 col-form-label">
                  {f.label}
                </Form.Label>
              )}
              <Col sm="9">
                { /* if you provided a full custom component, render it */ }
                {f.component ? (
                  f.component
                ) : (
                  /* otherwise fall back to a standard Form.Control */
                  <Form.Control
                    placeholder={f.placeholder || f.label}
                    type={f.type || 'text'}
                    name={f.name}
                    value={f.value}
                    onChange={f.onChange}
                    isInvalid={!!f.isInvalid}
                  />
                )}

                { /* validation feedback */ }
                {f.component ? (
                  /* if your custom component doesn’t do its own feedback: */
                  f.error && (
                    <div style={{ display: 'block', color: '#dc3545' }} className="invalid-feedback">
                      {f.error}
                    </div>
                  )
                ) : (
                  <Form.Control.Feedback type="invalid">
                    {f.error}
                  </Form.Control.Feedback>
                )}
              </Col>
            </Form.Group>
          </Col>
        );
      })}
    </Form.Group>
  );
};

export default HorizontalFieldsRow;

